export const ASL_STATION_INFO = 'asl-station-details';
export const ASL_EQUIPMENT_INFO = 'asl-equipment-details';
export const ASL_OTHERS_INFO = 'other-details';

export const ASL_SUPPORTING_DOCUMENTS = 'supporting-documents';

export const AMATEUR_STATION_APPLICATION = [    
    {
        sectionID: ASL_STATION_INFO,
        sectionName: 'Station Information',
        fieldList: [
            {
                id: 'station-name',
                label: 'Station Name',
                type: 'text'
            },
            {
                id: 'assigned-call-sign',
                label: 'Assigned Call Sign',
                type: 'text'
            },
            {
                id: 'occupation',
                label: 'Occupation/Designation',
                type: 'text'
            },
            {
                id: 'operator-qualification',
                label: 'Amateur Operator Qualifcation',
                type: 'text'
            },
            {
                id: 'postal',
                label: 'Postal Code',
                type: 'postal',
                rule: { required: true }
            },
            {
                id: 'block-house',
                label: 'Block/House No.',
                type: 'text'
            },
            {
                id: 'street',
                label: 'Street Name',
                type: 'text',
                rule: { required: true, charLength: 32 }
            },
            {
                id: 'building',
                label: 'Building Name',
                type: 'text',
                rule: { charLength: 66 }
            },
            {
                id: 'floor',
                label: 'Floor No.',
                type: 'text',
                span: 2,
                placeholder: 'Eg: 01, B1, 01M',
                rule: { charLength: 3 }
            },
            {
                id: 'unit',
                label: 'Unit No.',
                type: 'text',
                span: 2,
                placeholder: 'Eg: #05-01, use 01',
                rule: { charLength: 5 },
                isNextEmpty: true
            },
            {
                id: 'location',
                label: 'Location of Station',
                type: 'text'
            },
            {
                id: 'certificate-no',
                label: 'Certificate No.',
                type: 'text'
            },
        ]
    },
    {
        sectionID: ASL_EQUIPMENT_INFO,
        sectionName: 'Equipment Information',
        fieldList: [
            {
                id: 'equipmentInfoTable',
                label: ' ',
                type: 'table',
                subFields: [
                    {
                        id: 'manufacturer',
                        header: 'Manufacturer',
                        type: 'text'
                    },
                    {
                        id: 'model',
                        header: 'Model',
                        type: 'text'
                    },
                    {
                        id: 'outputPower',
                        header: 'Output Power(W)',
                        type: 'text'
                    },
                    {
                        id: 'frequencyRangeFrom',
                        header: 'Frequency Range(MHz)(Tranmitter)From',
                        type: 'text'
                    },
                    {
                        id: 'frequencyRangeTo',
                        header: 'Frequency Range(MHz)(Tranmitter)To',
                        type: 'text'
                    }
                ],
                span: 12
            }

        ]
    },
    {
        sectionID: ASL_OTHERS_INFO,
        sectionName: 'Others',
        fieldList: [
            {
                id: 'public-contact',
                label: 'Public Contact No.',
                type: 'text'
            },
            {
                id: 'proposed-use',
                label: 'Proposed Use of System',
                type: 'text'
            },
            {
                id: 'remarks',
                label: 'Remarks',
                type: 'text'
            }
        ]
    },
    {
        sectionID: ASL_SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
